import * as React from 'react';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import ProductListingGrid from '../ProductListingGrid/ProductListingGrid.js';
import ProductListingGridCell from '../ProductListingGridCell/ProductListingGridCell.js';

const ProductListingSkeleton = ({ pageSize  })=>{
    const { getLabel  } = useIntl();
    const skeletonGrid = React.useMemo(()=>Array.from({
            length: pageSize
        }).map((_, i)=>/*#__PURE__*/ React.createElement(ProductListingGridCell, {
                key: `skeleton-cell-${i}`
            }, /*#__PURE__*/ React.createElement(SkeletonLoader, {
                className: "product-listing-skeleton-loader"
            }, /*#__PURE__*/ React.createElement("svg", {
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                height: "220",
                "aria-label": getLabel('common.loadingText')
            }, /*#__PURE__*/ React.createElement("rect", {
                width: "100%",
                height: "100",
                rx: "5",
                fill: "currentColor"
            }), /*#__PURE__*/ React.createElement("rect", {
                width: "80%",
                height: "15",
                rx: "5",
                fill: "currentColor",
                x: "10%",
                y: "140"
            }), /*#__PURE__*/ React.createElement("rect", {
                width: "80%",
                height: "15",
                rx: "5",
                fill: "currentColor",
                x: "10%",
                y: "165"
            }), /*#__PURE__*/ React.createElement("rect", {
                width: "50%",
                height: "15",
                rx: "5",
                fill: "currentColor",
                x: "25%",
                y: "200"
            }))))
        )
    , [
        getLabel,
        pageSize
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-listing-skeleton"
    }, /*#__PURE__*/ React.createElement(ProductListingGrid, null, skeletonGrid));
};
var ProductListingSkeleton$1 = ProductListingSkeleton;

export { ProductListingSkeleton, ProductListingSkeleton$1 as default };
//# sourceMappingURL=ProductListingSkeleton.js.map
